import { render, staticRenderFns } from "./dialogVoucherCreditDetails.vue?vue&type=template&id=09f94e5a&scoped=true"
import script from "./dialogVoucherCreditDetails.vue?vue&type=script&lang=js"
export * from "./dialogVoucherCreditDetails.vue?vue&type=script&lang=js"
import style0 from "./dialogVoucherCreditDetails.vue?vue&type=style&index=0&id=09f94e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f94e5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDataTable,VDialog})
